import axios from 'axios'

export default {
  TOGGLE_LOADING (state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING (state) {
    state.searching = (state.searching === '') ? 'loading' : ''
  },
  SET_USER (state, user) {
    state.user = user
  },
  SET_USER_IMAGE (state, userimage) {
    state.user.profilePic = userimage
  },
  SET_SELECTED_USER (state, user) {
    state.selectedUser = user
  },
  UPDATED_PASSWORD (state) {
    state.user.nextloginreset = false
  },
  RESET_SELECTED_USER (state, user) {
    state.selectedUser = null
  },
  SET_ROLE (state, role) {
    state.selectedRole = role
  },
  SET_COMPANY (state, company) {
    state.company = company
  },
  LOGOFF (state) {
    state.user = null
    state.token = null
    state.selectedRole = null
    state.evid = null
    state.details = null
    state.atividades = null
    state.company = null
    state.selectedUser = null
  },
  SET_TOKEN (state, token) {
    state.token = token
    axios.defaults.headers.common['Authorization'] = token
  },
  SET_EVID (state, evid) {
    state.evid = evid
  },
  SET_DETAILS (state, info) {
    state.details = info
  },
  SET_ATIVIDADES (state, lista) {
    state.atividades = lista
  },
  SET_CENTRAL (state, central) {
    state.central = central
  },
  SET_NUMBER (state, badge) {
    state.badge = badge
  },
  SET_LISTPROJ (state, lista) {
    state.listproj = lista
  },
  getters () {
    return {
      loginReset: state => { return state.user.nextloginreset },
      currentPermissions: state => { return state.selectedRole.permissions }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js